export default function SuitableAudience() {
  const audiences = [
    { icon: 'ri-user-line', title: 'Менеджеры по продажам', desc: 'Ежедневные переговоры с клиентами, защита цены, работа с возражениями' },
    { icon: 'ri-user-star-line', title: 'Руководители отдела продаж', desc: 'Стратегические переговоры, работа с ключевыми клиентами, наставничество' },
    { icon: 'ri-briefcase-line', title: 'Коммерческие директора', desc: 'Партнёрские соглашения, крупные сделки, переговоры на уровне первых лиц' },
    { icon: 'ri-customer-service-line', title: 'Отдел сервиса', desc: 'Переговоры с недовольными клиентами, продление, работа с претензиями' },
    { icon: 'ri-store-line', title: 'Отдел закупок', desc: 'Переговоры с поставщиками, тендеры, снижение закупочных цен' },
    { icon: 'ri-vip-crown-line', title: 'Руководители высшего звена', desc: 'Стратегические переговоры, партнёрства, межведомственные коммуникации' },
    { icon: 'ri-projector-line', title: 'Проектные менеджеры', desc: 'Переговоры с заказчиками, управление ожиданиями, согласование изменений' },
    { icon: 'ri-building-line', title: 'Собственники бизнеса', desc: 'Переговоры с инвесторами, партнёрами, ключевыми контрагентами' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для кого подходит <strong>тренинг по переговорам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Переговоры ведут не только продавцы. Каждый сотрудник, который взаимодействует с клиентами, партнёрами, поставщиками или коллегами из других подразделений, — переговорщик.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {audiences.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}